import {AttributeEntityType} from '@/types/attribute-entity-type'

 
const TABLE_MAP: Record<AttributeEntityType, string> = {
    [AttributeEntityType.IDENTITY]: 'identity_attributes',
    [AttributeEntityType.PARTY]: 'party_attributes',
    [AttributeEntityType.RESOURCE]: 'resource_attributes',
    [AttributeEntityType.FUNCTION_GROUP]: 'function_group_attributes',
    [AttributeEntityType.TARGET_SYSTEM]: 'target_system_attributes',
    [AttributeEntityType.CONNECTOR]: 'connector_attributes',
    [AttributeEntityType.REPORT]: 'report_attributes',
    [AttributeEntityType.ACCESS_PROFILE]: 'access_profile_attributes',
    [AttributeEntityType.ACCOUNT]: 'account_attributes',
    [AttributeEntityType.ENFORCEMENT_OBJECT]: 'enforcement_object_attributes',
}
 

export function entityTypeToTableName(entityType: AttributeEntityType): string {
    return TABLE_MAP[entityType]
}
